<template>
  <div class="page">
      <div class="new-details" v-loading="state">
        <!--<div  class="new-details-title">{{title}} > </div>-->
      <!--  <div class="new-details-title">
          <div>{{title +'>'+data.articleTitle}}</div>
        </div>-->
        <div class="new-details-main">
          <div class="new-details-main-title">
            <div>{{data.articleTitle}}</div>
            <div><img src="~@/assets/img/new-time.png" width="20" height="20"/>{{'　'+data.createTime}}</div>
          </div>
          <div class="new-details-main-content">
            <div v-if="data.articleType == 3">
              <video  controls width="1040" height="600" autoplay="autoplay" >
                <source :src="data.articleContent" type="video/mp4">
                </video>
            </div>
            <div v-if="data.articleType == 4">
              <img :src="data.articleContent" width="1040" />
            </div>
            <div v-html="data.articleContent" v-if="data.articleType !== 3 && data.articleType !== 4"></div>
          </div>
        </div>
        <div class="new-details-bottom">
          <div @click="open(previous.id)">上一篇：{{previous.articleTitle}}</div>
          <div @click="open(next.id)">下一篇：{{next.articleTitle}}</div>
        </div>
      </div>
  </div>
</template>


<style scoped>
  .new-details{
    min-height: 800px;

  }
  .new-details-main{
    min-height: 700px;
    margin: 50px;
    background-color: RGB(244,247,251);
  }

  .new-details-title{
    margin: 10px;
    display: flex;
    align-items: flex-start;
    justify-items: center;
    flex-direction: row;
  }

  .new-details-main-title{
    padding: 50px 50px 0px 50px;
  }
  .new-details-main-title > div:nth-child(1){
    padding: 20px;
    font-size: x-large;
  }

  .new-details-main-title > div:nth-child(2){
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    color: #a5a5a5;
  }

  .new-details-main-content{
    padding: 30px;
    text-align: start;
    font-size: 18px;
  }


  .new-details-title{
    user-select: none;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    padding: 20px 0px;
    border-bottom: #b0b2b6 solid 2px;
    color: #b0b2b6;
    letter-spacing: 3px;
  }

  .new-details-title > div{
    margin: 0px 30px;
  }


  .new-details-bottom{
    padding:30px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
    user-select: none;
   }

  .new-details-bottom > div{
    padding:10px;
  }
  .new-details-bottom > div:hover{
    color: red;
  }
</style>

<script>
    export default {
        name: "new-details",
      data () {
        return {
          title :'',
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          state : false,
          previous: {
            id:'',
            articleTitle: ''
          },
          next:{
            id:'',
            articleTitle: ''
          },
          data:{
            articleTitle: '',
            createTime: '',
            articleContent: ''
          }
        }
      },
      mounted: function () {
          this.title = this.$route.query.title
        console.log(this.$route.query.classType)
          this.getDataList(this.$route.query.id,this.$route.query.classType)
        },
      methods: {
        open(id){
          if(id){
            window.scrollTo(0,0);
            this.getDataList(id)
           }
        },
        getDataList(id,classType){
          this.state  = true
          this.$http({
            url: this.$http.adornUrl('/website/getDetailInfo'),
            method: 'post',
            data: this.$http.adornData({
              "id":id,
              "classType": classType
            })
          }).then(({data}) => {
            this.state  = false
            if (data && data.code === 0) {
              this.data = data.data
              if(data.data.previous){
                  this.previous = data.data.previous
              }
              if(data.data.next){
                this.next = data.data.next
              }
            } else {
              this.$message.error("服务器无响应!")
            }
          })
        },
        // 每页数
        sizeChangeHandle (val) {
          this.pageSize = val
          this.pageIndex = 1
          this.getDataList()
        },
        // 当前页
        currentChangeHandle (val) {
          this.pageIndex = val
          this.getDataList()
        },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/modules/new-details.vue